/* eslint-disable
    import/no-unresolved,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./clientOverviewDetails.scss');

const deps = [
  require('angular-ui-router'),
  require('data/model/address').name,
  require('data/model/client').name,
  require('data/model/clientinfo').name,
  require('data/collection/ledger').name,
  require('data/collection/addon').name,
  require('ui/web/notifications').name,
];

module.exports = angular
  .module('bench.ui.clientOverview.details', deps)

  .directive('blClientOverviewDetails', () => ({
    restrict: 'E',
    scope: {
      clientId: '=',
    },
    bindToController: true,
    template: require('./clientOverviewDetails.html'),
    controller: require('./clientOverviewDetailsCtrl.js'),
    controllerAs: 'vm',
  }));
